import React from "react";
import {Link} from "react-router-dom";

import BlogImg4 from "../assets/blog-img4.svg";
import TriangularDown from "../assets/triangular-bg-demo-down.svg";
// import BlogPostList from "../data-blogposts.js";
import BlogPreview, {getImage} from "../data-blogpreview.js";

import "./BlogPosts.css";

function BlogPosts() {
    return (
        <div>
            <section className="highlighted-blogposts">
                <section className="highlighted-articles-container">
                    {BlogPreview.sort(() => Math.random() - Math.random()).slice(0, 4).map((blog, index) => blog.size === 'small' && (
                        <article
                            className="highlighted-article-card"
                            key={index}
                        >
                            <div style={{height: '200px', width: '100%'}}>
                                <a href={blog.link}>
                                    <figure>
                                        <img
                                            src={getImage(blog.image, blog.size === 'large')}
                                            alt={blog.title}
                                            height='200px'
                                            width='100%'
                                        />
                                    </figure>
                                </a>
                            </div>
                            <div className="highlighted-article-content">
                                <div style={{
                                    color: '#64748B',
                                    fontSize: 14,
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    wordWrap: 'break-word'
                                }}>How to guide
                                </div>
                                <h3>{blog.title}</h3>
                            </div>
                        </article>
                    ))}
                </section>
                <div className="highlighted-blogposts-header">
                    <a href="/blog">See all blogposts</a>
                </div>
            </section>
        </div>
    );
}

export default BlogPosts;
